import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    FaFileAlt,
    FaUser,
    FaIdCard,
    FaPhone,
    FaEnvelope,
    FaHome,
    FaUpload,
    FaFilePdf,
    FaCheckCircle,
    FaArrowLeft,
    FaArrowRight,
    FaInfoCircle,
    FaCalendarCheck,
    FaClipboardList,
    FaPrint,
    FaMapMarkedAlt,
    FaClock,
    FaSearch,
    FaBuilding,
    FaBriefcase,
    FaUserCheck,
    FaExclamationTriangle,
    FaGraduationCap,
    FaHeart,
    FaHandsHelping,
    FaStore,
    FaMoneyBillWave,
    FaCalendarAlt,
    FaDownload,
    FaEye,
    FaEdit
} from 'react-icons/fa';

const SuketMandiri = () => {
    const [activeTab, setActiveTab] = useState('daftar');
    const [selectedSurat, setSelectedSurat] = useState(null);
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        // Data Umum
        namaLengkap: '',
        nik: '',
        tempatLahir: '',
        tanggalLahir: '',
        jenisKelamin: 'L',
        agama: '',
        pekerjaan: '',
        noTelp: '',
        email: '',
        alamat: '',
        rt: '',
        rw: '',
        kelurahan: '',
        kecamatan: '',

        // Data Spesifik per Jenis Surat
        // Domisili
        alamatDomisili: '',
        lamaTinggal: '',
        statusTempat: 'milik_sendiri',

        // Usaha
        namaUsaha: '',
        jenisUsaha: '',
        alamatUsaha: '',
        tahunMulai: '',
        jumlahKaryawan: '',
        omzetPerBulan: '',

        // Tidak Mampu
        pekerjaanOrangtua: '',
        penghasilanOrangtua: '',
        jumlahTanggungan: '',
        statusRumah: 'milik_sendiri',
        keperluan: '',

        // Kehilangan
        jenisDokumenHilang: '',
        nomorDokumen: '',
        tanggalKehilangan: '',
        lokasiKehilangan: '',
        kronologi: '',

        // Dokumen Upload
        ktp: null,
        kk: null,
        foto: null,
        suratPengantar: null,
        dokumenPendukung: null,
        suratKehilangan: null,
        sktm: null
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [nomorSurat, setNomorSurat] = useState('');
    const [showPreview, setShowPreview] = useState(false);

    const tabs = [
        { id: 'daftar', label: 'Jenis Surat', icon: FaFileAlt },
        { id: 'pengajuan', label: 'Pengajuan', icon: FaEdit },
        { id: 'status', label: 'Cek Status', icon: FaSearch },
    ];

    const jenisSuratList = [
        {
            id: 'domisili',
            judul: 'Surat Keterangan Domisili',
            icon: FaHome,
            deskripsi: 'Surat keterangan domisili untuk keperluan administrasi kependudukan',
            persyaratan: ['KTP', 'Kartu Keluarga', 'Surat Pengantar RT/RW', 'Pas Foto 3x4'],
            waktuProses: '1-2 hari kerja',
            biaya: 'Gratis',
            warna: 'from-blue-500 to-blue-700',
            contoh: 'Menerangkan bahwa yang bersangkutan berdomisili di alamat tertentu'
        },
        {
            id: 'usaha',
            judul: 'Surat Keterangan Usaha',
            icon: FaStore,
            deskripsi: 'Surat keterangan untuk legalitas usaha dan keperluan perbankan',
            persyaratan: ['KTP', 'KK', 'Foto Usaha', 'Surat Pengantar RT/RW', 'Pas Foto 3x4'],
            waktuProses: '2-3 hari kerja',
            biaya: 'Gratis',
            warna: 'from-green-500 to-green-700',
            contoh: 'Menerangkan bahwa yang bersangkutan memiliki usaha tertentu'
        },
        {
            id: 'tidak_mampu',
            judul: 'Surat Keterangan Tidak Mampu',
            icon: FaHandsHelping,
            deskripsi: 'Surat keterangan tidak mampu untuk keperluan bantuan sosial dan pendidikan',
            persyaratan: ['KTP', 'KK', 'Surat Pengantar RT/RW', 'Foto Rumah', 'Pas Foto 3x4'],
            waktuProses: '2-3 hari kerja',
            biaya: 'Gratis',
            warna: 'from-red-500 to-red-700',
            contoh: 'Menerangkan bahwa yang bersangkutan termasuk keluarga kurang mampu'
        },
        {
            id: 'kehilangan',
            judul: 'Surat Keterangan Kehilangan',
            icon: FaExclamationTriangle,
            deskripsi: 'Surat keterangan kehilangan dokumen atau barang berharga',
            persyaratan: ['KTP', 'KK', 'Surat Kehilangan dari Kepolisian', 'Dokumen Pendukung'],
            waktuProses: '1-2 hari kerja',
            biaya: 'Gratis',
            warna: 'from-orange-500 to-orange-700',
            contoh: 'Menerangkan bahwa yang bersangkutan kehilangan dokumen/barang tertentu'
        }
    ];

    const agamaOptions = ['Islam', 'Kristen', 'Katolik', 'Hindu', 'Budha', 'Konghucu'];
    const kelurahanOptions = [
        'Magelang', 'Cacaban', 'Panjang', 'Jurangombo Utara', 'Jurangombo Selatan',
        'Tidar Utara', 'Tidar Selatan', 'Rejowinangun Utara', 'Rejowinangun Selatan',
        'Kemirirejo', 'Kedungsari', 'Kramat Utara', 'Kramat Selatan', 'Magersari',
        'Wates', 'Potrobangsan', 'Gelangan'
    ];
    const kecamatanOptions = ['Magelang Utara', 'Magelang Tengah', 'Magelang Selatan'];

    const handleSelectSurat = (jenisId) => {
        setSelectedSurat(jenisId);
        setActiveTab('pengajuan');
        setStep(1);
        setFormData({
            namaLengkap: '', nik: '', tempatLahir: '', tanggalLahir: '', jenisKelamin: 'L',
            agama: '', pekerjaan: '', noTelp: '', email: '', alamat: '', rt: '', rw: '',
            kelurahan: '', kecamatan: '',
            alamatDomisili: '', lamaTinggal: '', statusTempat: 'milik_sendiri',
            namaUsaha: '', jenisUsaha: '', alamatUsaha: '', tahunMulai: '', jumlahKaryawan: '', omzetPerBulan: '',
            pekerjaanOrangtua: '', penghasilanOrangtua: '', jumlahTanggungan: '', statusRumah: 'milik_sendiri', keperluan: '',
            jenisDokumenHilang: '', nomorDokumen: '', tanggalKehilangan: '', lokasiKehilangan: '', kronologi: '',
            ktp: null, kk: null, foto: null, suratPengantar: null, dokumenPendukung: null, suratKehilangan: null, sktm: null
        });
        setErrors({});
        window.scrollTo(0, 0);
    };

    const validateStep = (stepNumber) => {
        const newErrors = {};

        if (stepNumber === 1) {
            if (!formData.namaLengkap) newErrors.namaLengkap = 'Nama lengkap wajib diisi';
            if (!formData.nik) newErrors.nik = 'NIK wajib diisi';
            else if (formData.nik.length !== 16) newErrors.nik = 'NIK harus 16 digit';
            if (!formData.tempatLahir) newErrors.tempatLahir = 'Tempat lahir wajib diisi';
            if (!formData.tanggalLahir) newErrors.tanggalLahir = 'Tanggal lahir wajib diisi';
            if (!formData.agama) newErrors.agama = 'Agama wajib dipilih';
            if (!formData.noTelp) newErrors.noTelp = 'Nomor telepon wajib diisi';
            if (!formData.alamat) newErrors.alamat = 'Alamat wajib diisi';
            if (!formData.rt) newErrors.rt = 'RT wajib diisi';
            if (!formData.rw) newErrors.rw = 'RW wajib diisi';
            if (!formData.kelurahan) newErrors.kelurahan = 'Kelurahan wajib dipilih';
            if (!formData.kecamatan) newErrors.kecamatan = 'Kecamatan wajib dipilih';
        }

        if (stepNumber === 2) {
            if (selectedSurat === 'domisili') {
                if (!formData.alamatDomisili) newErrors.alamatDomisili = 'Alamat domisili wajib diisi';
                if (!formData.lamaTinggal) newErrors.lamaTinggal = 'Lama tinggal wajib diisi';
            }
            if (selectedSurat === 'usaha') {
                if (!formData.namaUsaha) newErrors.namaUsaha = 'Nama usaha wajib diisi';
                if (!formData.jenisUsaha) newErrors.jenisUsaha = 'Jenis usaha wajib diisi';
                if (!formData.alamatUsaha) newErrors.alamatUsaha = 'Alamat usaha wajib diisi';
                if (!formData.tahunMulai) newErrors.tahunMulai = 'Tahun mulai usaha wajib diisi';
            }
            if (selectedSurat === 'tidak_mampu') {
                if (!formData.pekerjaanOrangtua) newErrors.pekerjaanOrangtua = 'Pekerjaan orangtua wajib diisi';
                if (!formData.penghasilanOrangtua) newErrors.penghasilanOrangtua = 'Penghasilan wajib diisi';
                if (!formData.jumlahTanggungan) newErrors.jumlahTanggungan = 'Jumlah tanggungan wajib diisi';
                if (!formData.keperluan) newErrors.keperluan = 'Keperluan surat wajib diisi';
            }
            if (selectedSurat === 'kehilangan') {
                if (!formData.jenisDokumenHilang) newErrors.jenisDokumenHilang = 'Jenis dokumen wajib diisi';
                if (!formData.tanggalKehilangan) newErrors.tanggalKehilangan = 'Tanggal kehilangan wajib diisi';
                if (!formData.lokasiKehilangan) newErrors.lokasiKehilangan = 'Lokasi kehilangan wajib diisi';
                if (!formData.kronologi) newErrors.kronologi = 'Kronologi wajib diisi';
            }
        }

        if (stepNumber === 3) {
            if (!formData.ktp) newErrors.ktp = 'Foto/Scan KTP wajib diupload';
            if (!formData.kk) newErrors.kk = 'Foto/Scan KK wajib diupload';
            if (!formData.suratPengantar) newErrors.suratPengantar = 'Surat pengantar RT/RW wajib diupload';
            if (selectedSurat === 'usaha' && !formData.foto) newErrors.foto = 'Foto usaha wajib diupload';
            if (selectedSurat === 'tidak_mampu' && !formData.foto) newErrors.foto = 'Foto rumah wajib diupload';
            if (selectedSurat === 'kehilangan' && !formData.suratKehilangan) newErrors.suratKehilangan = 'Surat kehilangan dari kepolisian wajib diupload';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleFileUpload = (e) => {
        const { name, files } = e.target;
        if (files[0]) {
            setFormData(prev => ({ ...prev, [name]: files[0] }));
            if (errors[name]) {
                setErrors(prev => ({ ...prev, [name]: '' }));
            }
        }
    };

    const nextStep = () => {
        if (validateStep(step)) {
            setStep(prev => prev + 1);
            window.scrollTo(0, 0);
        }
    };

    const prevStep = () => {
        setStep(prev => prev - 1);
        window.scrollTo(0, 0);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateStep(3)) return;

        setIsSubmitting(true);

        setTimeout(() => {
            const prefix = selectedSurat === 'domisili' ? 'SKD' : selectedSurat === 'usaha' ? 'SKU' : selectedSurat === 'tidak_mampu' ? 'SKTM' : 'SKK';
            const noSurat = prefix + '/' + new Date().getFullYear() + '/' + Math.random().toString(36).substr(2, 6).toUpperCase();
            setNomorSurat(noSurat);
            setShowSuccess(true);
            setIsSubmitting(false);
            window.scrollTo(0, 0);
        }, 2000);
    };

    const getSelectedSuratInfo = () => {
        return jenisSuratList.find(s => s.id === selectedSurat);
    };

    const renderStepIndicator = () => (
        <div className="flex items-center justify-center mb-8">
            {[
                { step: 1, label: 'Data Diri', icon: FaUser },
                { step: 2, label: 'Data Spesifik', icon: FaClipboardList },
                { step: 3, label: 'Upload Dokumen', icon: FaUpload }
            ].map((item, index) => (
                <React.Fragment key={item.step}>
                    <div className="flex flex-col items-center">
                        <div className={`w-12 h-12 rounded-full flex items-center justify-center text-lg font-bold transition-all duration-300 ${step >= item.step
                                ? 'bg-[#0D9488] text-white shadow-lg'
                                : 'bg-gray-300 text-gray-600'
                            }`}>
                            {step > item.step ? <FaCheckCircle /> : <item.icon />}
                        </div>
                        <span className={`mt-2 text-xs font-medium hidden md:block ${step >= item.step ? 'text-[#0D9488]' : 'text-gray-500'
                            }`}>
                            {item.label}
                        </span>
                    </div>
                    {index < 2 && (
                        <div className={`w-16 md:w-24 h-1 mx-2 transition-all duration-300 ${step > item.step ? 'bg-[#0D9488]' : 'bg-gray-300'
                            }`} />
                    )}
                </React.Fragment>
            ))}
        </div>
    );

    // Tampilan Sukses
    if (showSuccess) {
        const suratInfo = getSelectedSuratInfo();
        return (
            <div className="container mx-auto px-4 py-12">
                <div className="max-w-2xl mx-auto">
                    <div className="card-glass text-center">
                        <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
                            <FaCheckCircle className="text-6xl text-green-500" />
                        </div>
                        <h2 className="text-3xl font-bold text-[#1E3A8A] mb-4">
                            Pengajuan Surat Berhasil!
                        </h2>
                        <p className="text-gray-600 mb-6">
                            Terima kasih telah mengajukan permohonan {suratInfo?.judul}.
                            Berikut adalah nomor surat Anda:
                        </p>

                        <div className={`bg-gradient-to-r ${suratInfo?.warna} text-white p-6 rounded-lg mb-6`}>
                            <p className="text-sm opacity-80 mb-2">Nomor Surat</p>
                            <p className="text-3xl font-bold font-mono">{nomorSurat}</p>
                            <p className="text-sm mt-2 opacity-80">Gunakan nomor ini untuk mengecek status dan mengambil surat</p>
                        </div>

                        <div className="text-left bg-gray-50 p-6 rounded-lg mb-6">
                            <h3 className="font-bold text-[#1E3A8A] mb-3 flex items-center">
                                <FaClipboardList className="mr-2" />
                                Informasi Selanjutnya:
                            </h3>
                            <ul className="space-y-3 text-sm text-gray-600">
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    <span>Simpan nomor surat untuk mengecek status permohonan</span>
                                </li>
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    <span>Petugas akan memverifikasi dokumen dalam 1-2 hari kerja</span>
                                </li>
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    <span>Surat dapat diambil di kantor BPKAD setelah status "Selesai"</span>
                                </li>
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    <span>Bawa KTP asli saat pengambilan surat</span>
                                </li>
                                <li className="flex items-start">
                                    <FaClock className="text-blue-500 mt-1 mr-2 flex-shrink-0" />
                                    <span>Estimasi waktu proses: {suratInfo?.waktuProses}</span>
                                </li>
                            </ul>
                        </div>

                        <div className="flex flex-col md:flex-row gap-4">
                            <button
                                onClick={() => window.print()}
                                className="flex-1 bg-[#0F172A] text-white px-6 py-3 rounded-lg font-semibold hover:bg-opacity-90 transition-colors flex items-center justify-center"
                            >
                                <FaPrint className="mr-2" />
                                Cetak Bukti Pengajuan
                            </button>
                            <button
                                onClick={() => {
                                    setShowSuccess(false);
                                    setSelectedSurat(null);
                                    setActiveTab('daftar');
                                    setStep(1);
                                }}
                                className="flex-1 bg-gray-200 text-gray-700 px-6 py-3 rounded-lg font-semibold hover:bg-gray-300 transition-colors flex items-center justify-center"
                            >
                                <FaFileAlt className="mr-2" />
                                Ajukan Surat Baru
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-12">
            {/* Header */}
            <div className="mb-8">
                <div className="flex items-center space-x-3 mb-2">
                    <FaFileAlt className="text-4xl text-[#0D9488]" />
                    <h1 className="text-3xl md:text-4xl font-bold text-[#1E3A8A]">
                        Surat Keterangan Mandiri
                    </h1>
                </div>
                <p className="text-gray-600 text-lg ml-12">
                    Layanan pembuatan surat keterangan secara mandiri untuk berbagai keperluan
                </p>
            </div>

            {/* Tab Navigation */}
            <div className="flex flex-wrap gap-2 mb-8 border-b border-gray-200">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => {
                            setActiveTab(tab.id);
                            if (tab.id === 'daftar') setSelectedSurat(null);
                        }}
                        className={`flex items-center px-6 py-3 text-sm font-medium transition-all duration-200 border-b-2 ${activeTab === tab.id
                                ? 'border-[#0D9488] text-[#0D9488] bg-[#0D9488]/5'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                    >
                        <tab.icon className="mr-2" />
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Daftar Jenis Surat */}
            {activeTab === 'daftar' && (
                <div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                        {jenisSuratList.map((surat) => (
                            <div key={surat.id} className="card-glass overflow-hidden hover:shadow-xl transition-shadow cursor-pointer"
                                onClick={() => handleSelectSurat(surat.id)}>
                                <div className={`bg-gradient-to-r ${surat.warna} p-6 text-white`}>
                                    <div className="flex items-center justify-between">
                                        <surat.icon className="text-4xl" />
                                        <span className="bg-white/20 px-3 py-1 rounded-full text-sm">
                                            {surat.waktuProses}
                                        </span>
                                    </div>
                                    <h3 className="text-xl font-bold mt-3">{surat.judul}</h3>
                                    <p className="text-sm opacity-90 mt-1">{surat.deskripsi}</p>
                                </div>
                                <div className="p-6">
                                    <div className="mb-4">
                                        <h4 className="font-semibold text-[#1E3A8A] mb-2 flex items-center">
                                            <FaClipboardList className="mr-2" />
                                            Persyaratan:
                                        </h4>
                                        <ul className="space-y-2">
                                            {surat.persyaratan.map((syarat, idx) => (
                                                <li key={idx} className="flex items-center text-sm text-gray-600">
                                                    <FaCheckCircle className="text-green-500 mr-2 flex-shrink-0" />
                                                    {syarat}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="flex items-center justify-between border-t pt-4">
                                        <div className="flex items-center text-sm">
                                            <FaMoneyBillWave className="text-green-500 mr-2" />
                                            <span className="font-semibold text-green-600">{surat.biaya}</span>
                                        </div>
                                        <div className="flex items-center text-sm">
                                            <FaClock className="text-blue-500 mr-2" />
                                            <span className="text-gray-600">{surat.waktuProses}</span>
                                        </div>
                                    </div>
                                    <button className="btn-primary w-full mt-4">
                                        Ajukan Sekarang
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Info Tambahan */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div className="card-glass text-center">
                            <FaClock className="text-3xl text-[#0D9488] mx-auto mb-3" />
                            <h4 className="font-bold text-[#1E3A8A] mb-2">Proses Cepat</h4>
                            <p className="text-sm text-gray-600">Surat selesai dalam 1-3 hari kerja setelah verifikasi</p>
                        </div>
                        <div className="card-glass text-center">
                            <FaMoneyBillWave className="text-3xl text-[#0D9488] mx-auto mb-3" />
                            <h4 className="font-bold text-[#1E3A8A] mb-2">Gratis Biaya</h4>
                            <p className="text-sm text-gray-600">Semua jenis surat keterangan tidak dipungut biaya</p>
                        </div>
                        <div className="card-glass text-center">
                            <FaDownload className="text-3xl text-[#0D9488] mx-auto mb-3" />
                            <h4 className="font-bold text-[#1E3A8A] mb-2">Download Digital</h4>
                            <p className="text-sm text-gray-600">Surat dapat diunduh dalam format PDF setelah selesai</p>
                        </div>
                    </div>
                </div>
            )}

            {/* Form Pengajuan */}
            {activeTab === 'pengajuan' && (
                <div>
                    {!selectedSurat ? (
                        <div className="text-center py-12">
                            <FaFileAlt className="text-6xl text-gray-300 mx-auto mb-4" />
                            <h3 className="text-xl font-bold text-gray-500 mb-2">Pilih Jenis Surat Terlebih Dahulu</h3>
                            <p className="text-gray-400 mb-6">Silakan pilih jenis surat keterangan yang ingin diajukan</p>
                            <button onClick={() => setActiveTab('daftar')} className="btn-primary">
                                Lihat Jenis Surat
                            </button>
                        </div>
                    ) : (
                        <div>
                            {/* Info Surat Terpilih */}
                            {(() => {
                                const suratInfo = getSelectedSuratInfo();
                                return (
                                    <div className={`bg-gradient-to-r ${suratInfo?.warna} text-white p-6 rounded-xl mb-8`}>
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center">
                                                {suratInfo && <suratInfo.icon className="text-4xl mr-4" />}
                                                <div>
                                                    <h2 className="text-2xl font-bold">{suratInfo?.judul}</h2>
                                                    <p className="opacity-90">{suratInfo?.deskripsi}</p>
                                                </div>
                                            </div>
                                            <button
                                                onClick={() => { setSelectedSurat(null); setActiveTab('daftar'); }}
                                                className="bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg transition-colors"
                                            >
                                                Ganti Jenis Surat
                                            </button>
                                        </div>
                                    </div>
                                );
                            })()}

                            {renderStepIndicator()}

                            <div className="max-w-4xl mx-auto">
                                <div className="card-glass">
                                    <form onSubmit={handleSubmit}>
                                        {/* Step 1: Data Diri */}
                                        {step === 1 && (
                                            <div className="space-y-6">
                                                <div className="flex items-center pb-4 border-b border-gray-200">
                                                    <div className="w-12 h-12 bg-[#0D9488]/10 rounded-full flex items-center justify-center mr-3">
                                                        <FaUser className="text-xl text-[#0D9488]" />
                                                    </div>
                                                    <div>
                                                        <h2 className="text-xl font-bold text-[#1E3A8A]">Data Diri Pemohon</h2>
                                                        <p className="text-sm text-gray-500">Lengkapi data diri sesuai KTP</p>
                                                    </div>
                                                </div>

                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            Nama Lengkap <span className="text-red-500">*</span>
                                                        </label>
                                                        <input type="text" name="namaLengkap" value={formData.namaLengkap} onChange={handleInputChange}
                                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.namaLengkap ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                                                            placeholder="Masukkan nama lengkap sesuai KTP" />
                                                        {errors.namaLengkap && <p className="text-red-500 text-xs mt-1">{errors.namaLengkap}</p>}
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            NIK <span className="text-red-500">*</span>
                                                        </label>
                                                        <input type="text" name="nik" value={formData.nik} onChange={handleInputChange}
                                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.nik ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                                                            placeholder="Masukkan 16 digit NIK" maxLength="16" />
                                                        {errors.nik && <p className="text-red-500 text-xs mt-1">{errors.nik}</p>}
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            Tempat Lahir <span className="text-red-500">*</span>
                                                        </label>
                                                        <input type="text" name="tempatLahir" value={formData.tempatLahir} onChange={handleInputChange}
                                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.tempatLahir ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                                                            placeholder="Kota/Kabupaten tempat lahir" />
                                                        {errors.tempatLahir && <p className="text-red-500 text-xs mt-1">{errors.tempatLahir}</p>}
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            Tanggal Lahir <span className="text-red-500">*</span>
                                                        </label>
                                                        <input type="date" name="tanggalLahir" value={formData.tanggalLahir} onChange={handleInputChange}
                                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.tanggalLahir ? 'border-red-500 bg-red-50' : 'border-gray-300'}`} />
                                                        {errors.tanggalLahir && <p className="text-red-500 text-xs mt-1">{errors.tanggalLahir}</p>}
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">Jenis Kelamin</label>
                                                        <select name="jenisKelamin" value={formData.jenisKelamin} onChange={handleInputChange}
                                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent">
                                                            <option value="L">Laki-laki</option>
                                                            <option value="P">Perempuan</option>
                                                        </select>
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            Agama <span className="text-red-500">*</span>
                                                        </label>
                                                        <select name="agama" value={formData.agama} onChange={handleInputChange}
                                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.agama ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}>
                                                            <option value="">Pilih Agama</option>
                                                            {agamaOptions.map(agama => (
                                                                <option key={agama} value={agama}>{agama}</option>
                                                            ))}
                                                        </select>
                                                        {errors.agama && <p className="text-red-500 text-xs mt-1">{errors.agama}</p>}
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">Pekerjaan</label>
                                                        <input type="text" name="pekerjaan" value={formData.pekerjaan} onChange={handleInputChange}
                                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                            placeholder="Masukkan pekerjaan" />
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            Nomor Telepon <span className="text-red-500">*</span>
                                                        </label>
                                                        <input type="tel" name="noTelp" value={formData.noTelp} onChange={handleInputChange}
                                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.noTelp ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                                                            placeholder="08123456789" />
                                                        {errors.noTelp && <p className="text-red-500 text-xs mt-1">{errors.noTelp}</p>}
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                                                        <input type="email" name="email" value={formData.email} onChange={handleInputChange}
                                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                            placeholder="contoh@email.com" />
                                                    </div>

                                                    <div className="md:col-span-2">
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            Alamat <span className="text-red-500">*</span>
                                                        </label>
                                                        <textarea name="alamat" value={formData.alamat} onChange={handleInputChange} rows="2"
                                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.alamat ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                                                            placeholder="Masukkan alamat lengkap (jalan, gang, nomor)" />
                                                        {errors.alamat && <p className="text-red-500 text-xs mt-1">{errors.alamat}</p>}
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">RT <span className="text-red-500">*</span></label>
                                                        <input type="text" name="rt" value={formData.rt} onChange={handleInputChange}
                                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.rt ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                                                            placeholder="001" />
                                                        {errors.rt && <p className="text-red-500 text-xs mt-1">{errors.rt}</p>}
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">RW <span className="text-red-500">*</span></label>
                                                        <input type="text" name="rw" value={formData.rw} onChange={handleInputChange}
                                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.rw ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                                                            placeholder="001" />
                                                        {errors.rw && <p className="text-red-500 text-xs mt-1">{errors.rw}</p>}
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">Kelurahan <span className="text-red-500">*</span></label>
                                                        <select name="kelurahan" value={formData.kelurahan} onChange={handleInputChange}
                                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.kelurahan ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}>
                                                            <option value="">Pilih Kelurahan</option>
                                                            {kelurahanOptions.map(kel => (
                                                                <option key={kel} value={kel}>{kel}</option>
                                                            ))}
                                                        </select>
                                                        {errors.kelurahan && <p className="text-red-500 text-xs mt-1">{errors.kelurahan}</p>}
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">Kecamatan <span className="text-red-500">*</span></label>
                                                        <select name="kecamatan" value={formData.kecamatan} onChange={handleInputChange}
                                                            className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.kecamatan ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}>
                                                            <option value="">Pilih Kecamatan</option>
                                                            {kecamatanOptions.map(kec => (
                                                                <option key={kec} value={kec}>{kec}</option>
                                                            ))}
                                                        </select>
                                                        {errors.kecamatan && <p className="text-red-500 text-xs mt-1">{errors.kecamatan}</p>}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Step 2: Data Spesifik */}
                                        {step === 2 && (
                                            <div className="space-y-6">
                                                <div className="flex items-center pb-4 border-b border-gray-200">
                                                    <div className="w-12 h-12 bg-[#0D9488]/10 rounded-full flex items-center justify-center mr-3">
                                                        <FaClipboardList className="text-xl text-[#0D9488]" />
                                                    </div>
                                                    <div>
                                                        <h2 className="text-xl font-bold text-[#1E3A8A]">Data {getSelectedSuratInfo()?.judul}</h2>
                                                        <p className="text-sm text-gray-500">Lengkapi informasi spesifik sesuai jenis surat</p>
                                                    </div>
                                                </div>

                                                {/* Form Domisili */}
                                                {selectedSurat === 'domisili' && (
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                        <div className="md:col-span-2">
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Alamat Domisili <span className="text-red-500">*</span>
                                                            </label>
                                                            <textarea name="alamatDomisili" value={formData.alamatDomisili} onChange={handleInputChange} rows="3"
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.alamatDomisili ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                                                                placeholder="Masukkan alamat domisili lengkap" />
                                                            {errors.alamatDomisili && <p className="text-red-500 text-xs mt-1">{errors.alamatDomisili}</p>}
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Lama Tinggal <span className="text-red-500">*</span>
                                                            </label>
                                                            <input type="text" name="lamaTinggal" value={formData.lamaTinggal} onChange={handleInputChange}
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.lamaTinggal ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                                                                placeholder="Contoh: 5 tahun" />
                                                            {errors.lamaTinggal && <p className="text-red-500 text-xs mt-1">{errors.lamaTinggal}</p>}
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Status Tempat Tinggal</label>
                                                            <select name="statusTempat" value={formData.statusTempat} onChange={handleInputChange}
                                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent">
                                                                <option value="milik_sendiri">Milik Sendiri</option>
                                                                <option value="sewa">Sewa/Kontrak</option>
                                                                <option value="menumpang">Menumpang</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Form Usaha */}
                                                {selectedSurat === 'usaha' && (
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Nama Usaha <span className="text-red-500">*</span>
                                                            </label>
                                                            <input type="text" name="namaUsaha" value={formData.namaUsaha} onChange={handleInputChange}
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.namaUsaha ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder="Masukkan nama usaha" />
                                                            {errors.namaUsaha && <p className="text-red-500 text-xs mt-1">{errors.namaUsaha}</p>}
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Jenis Usaha <span className="text-red-500">*</span>
                                                            </label>
                                                            <input type="text" name="jenisUsaha" value={formData.jenisUsaha} onChange={handleInputChange}
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.jenisUsaha ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder="Contoh: Warung Makan, Bengkel" />
                                                            {errors.jenisUsaha && <p className="text-red-500 text-xs mt-1">{errors.jenisUsaha}</p>}
                                                        </div>
                                                        <div className="md:col-span-2">
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Alamat Usaha <span className="text-red-500">*</span>
                                                            </label>
                                                            <textarea name="alamatUsaha" value={formData.alamatUsaha} onChange={handleInputChange} rows="2"
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.alamatUsaha ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder="Masukkan alamat usaha" />
                                                            {errors.alamatUsaha && <p className="text-red-500 text-xs mt-1">{errors.alamatUsaha}</p>}
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Tahun Mulai Usaha <span className="text-red-500">*</span>
                                                            </label>
                                                            <input type="number" name="tahunMulai" value={formData.tahunMulai} onChange={handleInputChange}
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.tahunMulai ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder="Contoh: 2020" />
                                                            {errors.tahunMulai && <p className="text-red-500 text-xs mt-1">{errors.tahunMulai}</p>}
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Jumlah Karyawan</label>
                                                            <input type="number" name="jumlahKaryawan" value={formData.jumlahKaryawan} onChange={handleInputChange}
                                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                                placeholder="Jumlah karyawan" />
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Omzet per Bulan (Rp)</label>
                                                            <input type="number" name="omzetPerBulan" value={formData.omzetPerBulan} onChange={handleInputChange}
                                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                                placeholder="Estimasi omzet per bulan" />
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Form Tidak Mampu */}
                                                {selectedSurat === 'tidak_mampu' && (
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Pekerjaan Orangtua/Wali <span className="text-red-500">*</span>
                                                            </label>
                                                            <input type="text" name="pekerjaanOrangtua" value={formData.pekerjaanOrangtua} onChange={handleInputChange}
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.pekerjaanOrangtua ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder="Masukkan pekerjaan orangtua" />
                                                            {errors.pekerjaanOrangtua && <p className="text-red-500 text-xs mt-1">{errors.pekerjaanOrangtua}</p>}
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Penghasilan per Bulan <span className="text-red-500">*</span>
                                                            </label>
                                                            <input type="text" name="penghasilanOrangtua" value={formData.penghasilanOrangtua} onChange={handleInputChange}
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.penghasilanOrangtua ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder="Estimasi penghasilan per bulan" />
                                                            {errors.penghasilanOrangtua && <p className="text-red-500 text-xs mt-1">{errors.penghasilanOrangtua}</p>}
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Jumlah Tanggungan <span className="text-red-500">*</span>
                                                            </label>
                                                            <input type="number" name="jumlahTanggungan" value={formData.jumlahTanggungan} onChange={handleInputChange}
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.jumlahTanggungan ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder="Jumlah tanggungan keluarga" />
                                                            {errors.jumlahTanggungan && <p className="text-red-500 text-xs mt-1">{errors.jumlahTanggungan}</p>}
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Status Rumah</label>
                                                            <select name="statusRumah" value={formData.statusRumah} onChange={handleInputChange}
                                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent">
                                                                <option value="milik_sendiri">Milik Sendiri</option>
                                                                <option value="sewa">Sewa/Kontrak</option>
                                                                <option value="menumpang">Menumpang</option>
                                                            </select>
                                                        </div>
                                                        <div className="md:col-span-2">
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Keperluan Surat <span className="text-red-500">*</span>
                                                            </label>
                                                            <textarea name="keperluan" value={formData.keperluan} onChange={handleInputChange} rows="2"
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.keperluan ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder="Contoh: Untuk keperluan beasiswa, bantuan sosial, dll" />
                                                            {errors.keperluan && <p className="text-red-500 text-xs mt-1">{errors.keperluan}</p>}
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Form Kehilangan */}
                                                {selectedSurat === 'kehilangan' && (
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Jenis Dokumen Hilang <span className="text-red-500">*</span>
                                                            </label>
                                                            <select name="jenisDokumenHilang" value={formData.jenisDokumenHilang} onChange={handleInputChange}
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.jenisDokumenHilang ? 'border-red-500' : 'border-gray-300'}`}>
                                                                <option value="">Pilih Jenis Dokumen</option>
                                                                <option value="ktp">KTP</option>
                                                                <option value="kk">Kartu Keluarga</option>
                                                                <option value="akta">Akta Kelahiran</option>
                                                                <option value="ijazah">Ijazah</option>
                                                                <option value="stnk">STNK</option>
                                                                <option value="bpkb">BPKB</option>
                                                                <option value="sertifikat">Sertifikat Tanah</option>
                                                                <option value="lainnya">Dokumen Lainnya</option>
                                                            </select>
                                                            {errors.jenisDokumenHilang && <p className="text-red-500 text-xs mt-1">{errors.jenisDokumenHilang}</p>}
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Nomor Dokumen</label>
                                                            <input type="text" name="nomorDokumen" value={formData.nomorDokumen} onChange={handleInputChange}
                                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                                placeholder="Nomor dokumen yang hilang (jika ada)" />
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Tanggal Kehilangan <span className="text-red-500">*</span>
                                                            </label>
                                                            <input type="date" name="tanggalKehilangan" value={formData.tanggalKehilangan} onChange={handleInputChange}
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.tanggalKehilangan ? 'border-red-500' : 'border-gray-300'}`} />
                                                            {errors.tanggalKehilangan && <p className="text-red-500 text-xs mt-1">{errors.tanggalKehilangan}</p>}
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Lokasi Kehilangan <span className="text-red-500">*</span>
                                                            </label>
                                                            <input type="text" name="lokasiKehilangan" value={formData.lokasiKehilangan} onChange={handleInputChange}
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.lokasiKehilangan ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder="Tempat/lokasi kehilangan" />
                                                            {errors.lokasiKehilangan && <p className="text-red-500 text-xs mt-1">{errors.lokasiKehilangan}</p>}
                                                        </div>
                                                        <div className="md:col-span-2">
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Kronologi Kehilangan <span className="text-red-500">*</span>
                                                            </label>
                                                            <textarea name="kronologi" value={formData.kronologi} onChange={handleInputChange} rows="3"
                                                                className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.kronologi ? 'border-red-500' : 'border-gray-300'}`}
                                                                placeholder="Ceritakan kronologi kehilangan secara singkat" />
                                                            {errors.kronologi && <p className="text-red-500 text-xs mt-1">{errors.kronologi}</p>}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* Step 3: Upload Dokumen */}
                                        {step === 3 && (
                                            <div className="space-y-6">
                                                <div className="flex items-center pb-4 border-b border-gray-200">
                                                    <div className="w-12 h-12 bg-[#0D9488]/10 rounded-full flex items-center justify-center mr-3">
                                                        <FaUpload className="text-xl text-[#0D9488]" />
                                                    </div>
                                                    <div>
                                                        <h2 className="text-xl font-bold text-[#1E3A8A]">Upload Dokumen Pendukung</h2>
                                                        <p className="text-sm text-gray-500">Upload dokumen persyaratan sesuai jenis surat</p>
                                                    </div>
                                                </div>

                                                <div className="bg-yellow-50 p-4 rounded-lg mb-4 flex items-start">
                                                    <FaInfoCircle className="text-yellow-600 mt-1 mr-3 flex-shrink-0" />
                                                    <div>
                                                        <p className="text-sm font-semibold text-yellow-800 mb-1">Ketentuan Upload:</p>
                                                        <ul className="text-sm text-yellow-700 list-disc list-inside">
                                                            <li>Format: PDF, JPG, PNG (Maks. 2MB per file)</li>
                                                            <li>Tanda <span className="text-red-500">*</span> wajib diupload</li>
                                                            <li>Pastikan dokumen terbaca dengan jelas</li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="space-y-4">
                                                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                                        <div className="flex items-center justify-between">
                                                            <div>
                                                                <label className="text-sm font-medium text-gray-700">Foto/Scan KTP <span className="text-red-500">*</span></label>
                                                                {formData.ktp && <p className="text-sm text-green-600 mt-1">✓ {formData.ktp.name}</p>}
                                                                {errors.ktp && <p className="text-red-500 text-xs mt-1">{errors.ktp}</p>}
                                                            </div>
                                                            <label className="cursor-pointer bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm hover:bg-gray-50">
                                                                Pilih File
                                                                <input type="file" name="ktp" onChange={handleFileUpload} accept=".pdf,.jpg,.jpeg,.png" className="hidden" />
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                                        <div className="flex items-center justify-between">
                                                            <div>
                                                                <label className="text-sm font-medium text-gray-700">Foto/Scan Kartu Keluarga <span className="text-red-500">*</span></label>
                                                                {formData.kk && <p className="text-sm text-green-600 mt-1">✓ {formData.kk.name}</p>}
                                                                {errors.kk && <p className="text-red-500 text-xs mt-1">{errors.kk}</p>}
                                                            </div>
                                                            <label className="cursor-pointer bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm hover:bg-gray-50">
                                                                Pilih File
                                                                <input type="file" name="kk" onChange={handleFileUpload} accept=".pdf,.jpg,.jpeg,.png" className="hidden" />
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                                        <div className="flex items-center justify-between">
                                                            <div>
                                                                <label className="text-sm font-medium text-gray-700">Surat Pengantar RT/RW <span className="text-red-500">*</span></label>
                                                                {formData.suratPengantar && <p className="text-sm text-green-600 mt-1">✓ {formData.suratPengantar.name}</p>}
                                                                {errors.suratPengantar && <p className="text-red-500 text-xs mt-1">{errors.suratPengantar}</p>}
                                                            </div>
                                                            <label className="cursor-pointer bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm hover:bg-gray-50">
                                                                Pilih File
                                                                <input type="file" name="suratPengantar" onChange={handleFileUpload} accept=".pdf,.jpg,.jpeg,.png" className="hidden" />
                                                            </label>
                                                        </div>
                                                    </div>

                                                    {(selectedSurat === 'usaha' || selectedSurat === 'tidak_mampu') && (
                                                        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                                            <div className="flex items-center justify-between">
                                                                <div>
                                                                    <label className="text-sm font-medium text-gray-700">
                                                                        {selectedSurat === 'usaha' ? 'Foto Usaha' : 'Foto Rumah'} <span className="text-red-500">*</span>
                                                                    </label>
                                                                    {formData.foto && <p className="text-sm text-green-600 mt-1">✓ {formData.foto.name}</p>}
                                                                    {errors.foto && <p className="text-red-500 text-xs mt-1">{errors.foto}</p>}
                                                                </div>
                                                                <label className="cursor-pointer bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm hover:bg-gray-50">
                                                                    Pilih File
                                                                    <input type="file" name="foto" onChange={handleFileUpload} accept=".jpg,.jpeg,.png" className="hidden" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {selectedSurat === 'kehilangan' && (
                                                        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                                            <div className="flex items-center justify-between">
                                                                <div>
                                                                    <label className="text-sm font-medium text-gray-700">Surat Kehilangan dari Kepolisian <span className="text-red-500">*</span></label>
                                                                    {formData.suratKehilangan && <p className="text-sm text-green-600 mt-1">✓ {formData.suratKehilangan.name}</p>}
                                                                    {errors.suratKehilangan && <p className="text-red-500 text-xs mt-1">{errors.suratKehilangan}</p>}
                                                                </div>
                                                                <label className="cursor-pointer bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm hover:bg-gray-50">
                                                                    Pilih File
                                                                    <input type="file" name="suratKehilangan" onChange={handleFileUpload} accept=".pdf,.jpg,.jpeg,.png" className="hidden" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                                        <div className="flex items-center justify-between">
                                                            <div>
                                                                <label className="text-sm font-medium text-gray-700">Dokumen Pendukung Lainnya (Opsional)</label>
                                                                {formData.dokumenPendukung && <p className="text-sm text-green-600 mt-1">✓ {formData.dokumenPendukung.name}</p>}
                                                            </div>
                                                            <label className="cursor-pointer bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm hover:bg-gray-50">
                                                                Pilih File
                                                                <input type="file" name="dokumenPendukung" onChange={handleFileUpload} accept=".pdf,.jpg,.jpeg,.png" className="hidden" />
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Navigation Buttons */}
                                        <div className="flex justify-between mt-8 pt-6 border-t border-gray-200">
                                            {step > 1 ? (
                                                <button type="button" onClick={prevStep} className="flex items-center px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
                                                    <FaArrowLeft className="mr-2" /> Sebelumnya
                                                </button>
                                            ) : (
                                                <button type="button" onClick={() => { setSelectedSurat(null); setActiveTab('daftar'); }} className="flex items-center px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
                                                    <FaArrowLeft className="mr-2" /> Kembali
                                                </button>
                                            )}

                                            {step < 3 ? (
                                                <button type="button" onClick={nextStep} className="flex items-center btn-primary">
                                                    Selanjutnya <FaArrowRight className="ml-2" />
                                                </button>
                                            ) : (
                                                <button type="submit" disabled={isSubmitting} className={`flex items-center btn-primary ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                                    {isSubmitting ? (
                                                        <><div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>Mengirim Pengajuan...</>
                                                    ) : (
                                                        <><FaCheckCircle className="mr-2" />Kirim Pengajuan Surat</>
                                                    )}
                                                </button>
                                            )}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {/* Cek Status */}
            {activeTab === 'status' && (
                <div className="max-w-2xl mx-auto">
                    <div className="card-glass">
                        <h3 className="text-xl font-bold text-[#1E3A8A] mb-4 flex items-center">
                            <FaSearch className="mr-2 text-[#0D9488]" />
                            Cek Status Surat Keterangan
                        </h3>
                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Nomor Surat</label>
                                <input
                                    type="text"
                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                    placeholder="Masukkan nomor surat (SKD/2024/XXXXX)"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">NIK Pemohon</label>
                                <input
                                    type="text"
                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                    placeholder="Masukkan NIK pemohon"
                                />
                            </div>
                            <button className="btn-primary w-full">
                                <FaSearch className="mr-2 inline" /> Cek Status
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SuketMandiri;